
import DeleteIcon from '@mui/icons-material/Delete';
import { GrEdit } from "react-icons/gr";
import { useClientContext } from '../../../Context/ClientContext';
const Note = ({ id, title, description, color, createdAt, style, openEditModal }) => {

  const { DeleteNote } = useClientContext();

  return (
    <div key={id}
      className={`p-[14px] interview-card bg-${color}-300`}
      style={{
        backgroundColor: color,
        ...style,
      }}
    >
      <div className="flex justify-end items-center gap-[5px]">
        <button className="h-[30px] flex items-center justify-center w-[30px] rounded-md"
          onClick={() =>
            openEditModal({ id, title, description, color, createdAt })
          }
        >
          <GrEdit className="text-[#8a25b0] edit-icon" />
        </button>
        <button onClick={() => { DeleteNote(id) }} className="h-[30px] flex items-center justify-center w-[30px] rounded-md">
          <DeleteIcon className="text-[red] edit-icon" />
        </button>
      </div>
      <h4 className="font-medium mb-[10px] text-[20px] text-[#8a25b0] interview-heading">
        {title}
      </h4>
      <p className="mb-[10px] break-words">{description}</p>
      <div className="flex gap-[8px] items-center">
        <p className="text-[16px] text-[red] newcreated">Created at :</p>
        <span className="text-[#8a25b0] newcreated text-[14px]">
          {createdAt}
        </span>
      </div>
    </div>
  );
};

export default Note;